import { Loader } from '../utils/loader'
import { SERVICES } from '../config/constants'

class FamilyLoader extends Loader {
  // getAll = () => {
  //   throw new Error('Not implemented')
  // }
}

export const familyLoader = new FamilyLoader({
  service: SERVICES.per
})
